import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTable = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M3.5 4v12h13V4zM3 2.5a1 1 0 0 0-1 1v13a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-13a1 1 0 0 0-1-1z"
      clipRule="evenodd"
    />
    <path d="M3 6.5h14V8H3z" />
    <path d="M13 6.5v11h-1.5v-11zm-6 11v-11h1.5v11z" />
  </svg>
);
export default SvgTable;
